import React from 'react';
import { Link } from 'react-router-dom';
import Header from './shared/Header';
import Navigation from './shared/Navigation';
import { getRandomColor } from '../utils/colors';
const WorkshopsPage = () => {
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-740">
      <Header data-id="element-741" />
      <main className="flex min-h-screen pt-24 px-6 pb-16" data-id="element-742">
        <div className="flex flex-col md:flex-row w-full max-w-6xl mx-auto" data-id="element-743">
          <div className="w-full md:w-1/4 mb-8 md:mb-0" data-id="element-744">
            <Navigation data-id="element-745" />
          </div>
          <div className="w-full md:w-3/4 md:pl-8" data-id="element-746">
            <div className="max-w-2xl" data-id="element-747">
              <div className="mb-8" data-id="element-748">Workshops for 2026</div>
              <div className="mb-8" data-id="element-749">
                <div className="mb-1 line-through" data-id="element-750">
                  The Winter Practice Workshop (Online)
                </div>
                <div className="mb-1 line-through" data-id="element-751">
                  Saturdays 9am - 12pm EST
                </div>
                <div className="mb-1 line-through" data-id="element-752">
                  January 24th - February 21st, 2026
                </div>
                <div data-id="element-753">
                  <span className="line-through" data-id="element-754">
                    <Link to="/winter-practice-workshop" className="transition-colors duration-200" onMouseEnter={e => {
                    e.currentTarget.style.color = getRandomColor();
                  }} onMouseLeave={e => {
                    e.currentTarget.style.color = '#333333';
                  }} data-id="element-755">
                      Register here
                    </Link>
                  </span>{' '}
                  <span className="text-[#333333]" data-id="element-756">SOLD OUT</span>
                </div>
              </div>
              <div className="mb-8" data-id="element-757">
                <div className="mb-1 line-through" data-id="element-758">
                  Try Something New: 100 Images in Two Days
                </div>
                <div className="mb-1 line-through" data-id="element-759">
                  In-Person @{' '}
                  <a href="https://www.penumbrafoundation.org/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-760">
                    Penumbra Foundation
                  </a>
                </div>
                <div className="mb-1 line-through" data-id="element-761">
                  April 22nd - April 24th, 2026
                </div>
                <span className="line-through" data-id="element-762">
                  <a href="https://www.penumbrafoundation.org/workshops/try-something-new-100-images-in-two-days" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-763">
                    Register here
                  </a>
                </span>
              </div>
              <div className="mb-8" data-id="element-764">
                <div className="mb-1" data-id="element-765">Saturday Critique Group 1 (Online)</div>
                <div className="mb-1" data-id="element-766">Every four weeks, starting June 20th</div>
                <div className="mb-1" data-id="element-767">9am - 11:30am EST</div>
                <Link to="/saturday-critique-group" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-768">
                  Register here
                </Link>
              </div>
              <div className="mb-8" data-id="element-769">
                <div className="mb-1" data-id="element-770">
                  The Sum of the Parts: A Writing and Photography Workshop
                </div>
                <div className="mb-1" data-id="element-771">
                  Co-led by{' '}
                  <a href="https://www.vivianewing.com/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-772">
                    Vivian Ewing
                  </a>
                </div>
                <div className="mb-1" data-id="element-773">
                  In-Person @{' '}
                  <a href="https://www.mainemedia.edu/workshops/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-774">
                    Maine Media Workshops
                  </a>
                </div>
                <div className="mb-1" data-id="element-775">August 24th - August 28th, 2026</div>
                <a href="https://www.mainemedia.edu/workshops/item/the-sum-of-the-parts-a-writing-and-photography-workshop/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-776">
                  Register here
                </a>
              </div>
              <div className="mb-8" data-id="element-777">
                <div className="mb-1" data-id="element-778">
                  Photography & Storytelling: Thinking About the Photo Book
                </div>
                <div className="mb-1" data-id="element-779">
                  In-Person @{' '}
                  <a href="https://www.mainemedia.edu/workshops/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-780">
                    Maine Media Workshops
                  </a>
                </div>
                <div className="mb-1" data-id="element-781">
                  September 21st - September 25th, 2026
                </div>
                <div data-id="element-782">
                  <a href="https://www.mainemedia.edu/workshops/item/photography-and-storytelling-thinking-about-the-photo-book/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-783">
                    Register here
                  </a>
                </div>
              </div>
              <div className="mb-12" data-id="element-784">
                <div data-id="element-785">
                  One-on-one mentorship follows the{' '}
                  <a href="https://santafeworkshops.com/sfw-online/mentorships/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-786">
                    Santa Fe Mentorship Level 1
                  </a>{' '}
                  model. Email me directly to enquire.
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
};
export default WorkshopsPage;